import { RESET_ENTRY_STATE, SET_ENTRY_FIELD_PAYLOAD, UPDATE_ENTRY_FIELD_PAYLOAD } from "./action";

const initialEntryState = {
  fieldPayload: [],
};

const entryFieldReducer = (state = initialEntryState, action) => {
  switch (action.type) {
    case SET_ENTRY_FIELD_PAYLOAD:
      return {
        ...state,
        fieldPayload: action.payload,
      };

    case RESET_ENTRY_STATE:
      return initialEntryState;

    case UPDATE_ENTRY_FIELD_PAYLOAD:
 const updatedPayload = state.fieldPayload.map((field) =>
  field.dataName === action.payload.dataName
    ? { ...field, ...action.payload.updates }
    : field
);

if (!updatedPayload.find(field => field.dataName === action.payload.dataName)) {
  updatedPayload.push(action.payload.updates);
}

return {
  ...state,
  fieldPayload: updatedPayload,
};
case 'REMOVE_FIELD_FROM_ENTRY_PAYLOAD':
      // Filter out the field based on dataName
      return {
        ...state,
        fieldPayload: state.fieldPayload.filter(
          (field) => field.dataName !== action.payload
        ),
      };

    default:
      return state;
  }
};

export default entryFieldReducer;
